module.exports = __webpack_public_path__ + "peugeot.446ab4ebbadb7f3b5c30.png";